export default "__VITE_ASSET__SK$USxwx__"